// src/pages/UsageDownload.jsx
import React, { Component, Fragment } from "react";
import { Helmet } from 'react-helmet';
import HeaderOne from '../components/header/HeaderOne';
import Footer from '../components/footer/Footer';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiDownload, FiTerminal, FiGithub, FiBookOpen, FiInfo } from "react-icons/fi"; // Added FiInfo
import Breadcrumb from "../components/common/Breadcrumb";
import { Link } from 'react-router-dom'; // Import Link for internal navigation

// Updated info - version can refer to the source state
const latestVersion = "0.1.0-alpha"; // Example: reflects experimental state
const releaseDate = "Updated: January 15, 2024"; // Example: last significant source update date
const gitHubRepoLink = "https://github.com/xuzzu/eidocell"; // Main repo link
const gitHubReleasesLink = "https://github.com/xuzzu/eidocell/releases"; // Releases page

const downloadOptions = [
    {
        os: "Source Code",
        icon: <FiGithub />,
        description: "Get the latest source code from GitHub to set up the environment and run Eidocell.",
        link: `${gitHubRepoLink}/archive/refs/heads/main.zip`, // Link to download main branch as zip
        fileName: `eidocell-main.zip`,
        type: "ZIP Archive",
        notes: <>Clone or download the repository. Follow the <Link to="/usage/startup#installation">setup instructions</Link> to run.</>
    }
];

class UsageDownload extends Component {
    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>Get Eidocell | Source Code & Setup Guide</title>
                    <meta name="description" content={`Access the Eidocell source code. Currently, Eidocell (v${latestVersion}) must be run from source. Find setup guides and future plans for executables.`} />
                </Helmet>

                <HeaderOne />

                <Breadcrumb title={'Get Eidocell'} />

                <div className="main-content-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 offset-lg-1">
                                <div className="download-page-content">
                                    <div className="alert alert-warning text-center mb--40" role="alert" style={{backgroundColor: "rgba(255,193,7,0.2)", border: "1px solid rgba(255,193,7,0.5)", color: "#fff"}}>
                                        <h4 className="alert-heading" style={{color: "#ffc107"}}><FiInfo size={24} style={{ marginRight: '10px', verticalAlign: 'middle' }} />Important Notice</h4>
                                        <p className="mb-0">
                                            Executable builds for Windows, macOS, and Linux are <strong>not yet available</strong> for direct download.
                                            I am working towards providing these in the future.
                                        </p>
                                        <hr style={{borderColor: "rgba(255,193,7,0.3)"}}/>
                                        <p className="mb-0">
                                            Currently, Eidocell must be <strong>run from the source code</strong>. Please follow the instructions in our <Link to="/usage/startup" style={{color: "#ffc107", fontWeight: "bold"}}>Getting Started Guide</Link>.
                                        </p>
                                    </div>

                                    <div className="download-options-grid">
                                        {downloadOptions.map(option => (
                                            <div className="download-option-card" key={option.os} style={option.os.includes("Source Code") ? {gridColumn: "1 / -1"} : {}}>
                                                <div className="card-icon">{option.icon}</div>
                                                <h3 className="card-title">{option.os}</h3>
                                                <p className="card-description">{option.description}</p>
                                                <a href={option.link} className="download-button ar-button style-flat secondary" download={option.fileName} target="_blank" rel="noopener noreferrer">
                                                    <FiDownload /> Download {option.type}
                                                </a>
                                                {option.notes && <p className="post-download-note">{option.notes}</p>}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="additional-info mt--60 text-center">
                                        <h3 className="text-white">Setup & Installation from Source</h3>
                                        <p className="text-white opacity-85">
                                            For detailed instructions on setting up your Python environment, cloning the repository, installing dependencies, and running Eidocell from source, please consult the <Link to="/usage/startup">Getting Started Guide</Link>.
                                        </p>
                                        <hr className="my--40" style={{borderColor: "rgba(255,255,255,0.2)"}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
            </Fragment>
        )
    }
}

export default UsageDownload;